<template>
  <div class="data-dictionary-box">
    <Catalog
      :currCatalog="currCatalog"
      @handleCatalogClick="handleCatalogClick" />
    <div class="content-box">
      <div class="header-box">{{ currCatalog.name }}</div>
      <div class="operation-box">
        <div class="action-box">
          <el-button
            v-if="isChecked('Project.Single.ProjectDataDictionary.Add')"
            size="small"
            class="primary-btn"
            type="primary"
            @click="openEditDialog()">
            添加
          </el-button>
          <el-button
            v-if="isChecked('Project.Single.ProjectDataDictionary.Import')"
            size="small"
            class="normal-btn gr8"
            @click="openImportDialog()">
            导入
          </el-button>
          <div
            class="common-dropdown-box gr8"
            v-if="isChecked('Project.Single.ProjectDataDictionary.Export')">
            <el-dropdown
              placement="bottom-start"
              @command="batchOperate">
              <el-button
                size="small"
                class="normal-btn">
                批量导出 <i class="el-icon-arrow-down" />
              </el-button>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-menu dropdown-primary"
                :append-to-body="false">
                <el-dropdown-item command="1"> 导出全部 </el-dropdown-item>
                <el-dropdown-item command="2"> 导出所选部分 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-button
            v-if="isChecked('Project.Single.ProjectDataDictionary.BatchDelete')"
            size="small"
            class="normal-btn"
            @click="batchDelete">
            批量删除
          </el-button>
        </div>
        <div class="filter-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入相关内容"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search icon"
              @click="search" />
          </el-input>
        </div>
      </div>
      <div class="common-table-box">
        <div v-if="isLoading">
          <Spin
            :pointNum="8"
            :translateX="25"
            background="var(--base-primary-bgColor)" />
        </div>
        <el-table
          v-else
          ref="catalogTable"
          class="publish-table"
          :header-row-class-name="customHeader"
          :data="dataList"
          highlight-selection-row
          height="100%"
          @select="selectChange"
          @select-all="selectChange">
          <el-table-column
            type="selection"
            width="60" />
          <el-table-column
            label="序号"
            type="index"
            width="55">
            <template #default="scope">
              <span class="serialNumber">
                {{ scope.$index + 1 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="名称">
            <template v-slot="{ row }">
              <div
                class="text-overflow"
                :title="row.name">
                {{ row.name }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="创建日期">
            <template v-slot="{ row }">
              <div class="timetransfer">
                {{
                  row?.lastModificationTime
                    ? formatTime(row?.lastModificationTime)
                    : formatTime(row?.creationTime)
                }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            label="操作"
            width="150"
            v-if="isOperationVisible()">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="
                    isChecked('Project.Single.ProjectDataDictionary.Update')
                  "
                  type="text"
                  size="small"
                  @click="openEditDialog(row)">
                  编辑
                </el-button>
                <el-button
                  v-if="
                    isChecked('Project.Single.ProjectDataDictionary.Delete')
                  "
                  type="text"
                  size="small"
                  @click="deleteDataById(row)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="common-empty-box">
              <bj-empty class="empty-page">
                <template>
                  <div class="empty-text">抱歉，没有找到相关内容</div>
                </template>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
      <div class="common-pagination-box pagination-primary">
        <el-pagination
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currPage"
          :total="total"
          @size-change="sizeChange"
          @current-change="pageChange">
        </el-pagination>
      </div>
    </div>
    <CatalogContentDialog
      :visible="isCatalogDialogVisible"
      :dataInfo="currDictionary"
      @refreshDictionaryList="refreshDictionaryList"
      @closeDialog="closeEditDialog" />
    <ImportFileDialog
      :visible="isImportDialogVisible"
      :currCatalog="currCatalog"
      @refreshDictionaryList="refreshDictionaryList"
      @closeDialog="closeImportDialog" />
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import Catalog from './Catalog.vue'
import CatalogContentDialog from './CatalogContentDialog.vue'
import ImportFileDialog from './ImportFileDialog.vue'

import { Store } from '@/utils/store'
import { formatTime } from '@/utils/generalMethods'

import {
  getDataDictionaryService,
  deleteDataDictionaryCheckService,
  batchDeleteDataDictionaryService
} from '@/service/dataDictionary'

export default {
  data() {
    return {
      isLoading: true,
      currCatalog: {},
      keywords: '',
      pageSize: 10,
      currPage: 1,
      total: 0,
      customHeader: '',
      dataList: [],
      selectDatas: [],
      currDictionary: {},

      isCatalogDialogVisible: false,
      isImportDialogVisible: false
    }
  },
  components: {
    Spin,
    Catalog,
    CatalogContentDialog,
    ImportFileDialog
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.catalogTable.bodyWrapper
      currentBody.addEventListener('scroll', ev => {
        const scrollTop = ev.target.scrollTop
        this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
      })
    }, 1000)
  },
  methods: {
    async handleCatalogClick(catalogInfo) {
      this.isLoading = true

      this.currCatalog = catalogInfo
      this.currPage = 1
      let dataList = await this.queryDictionaryList()
      this.dataList = dataList

      this.isLoading = false
    },
    search() {
      this.refreshDictionaryList()
    },
    async pageChange(page) {
      this.currPage = page
      let dataList = await this.queryDictionaryList()
      this.dataList = dataList
    },
    async sizeChange(size) {
      this.pageSize = size
      this.currPage = 1
      let dataList = await this.queryDictionaryList()
      this.dataList = dataList
    },
    batchOperate(command) {
      switch (command) {
        case '1': {
          this.currPage = 1
          this.pageSize = 10000
          this.queryDictionaryList().then(dataList => {
            let array = dataList.map(item => item.name)
            if (!array.length) {
              this.$message.warning('当前没有数据，请新建数据后再导出')
              this.pageSize = 10
              return
            }
            this.pageSize = 10
            this.exportDatas(array)
          })
          break
        }
        case '2': {
          let array = this.selectDatas.map(item => item.name)
          if (!array.length) {
            this.$message.warning('请选择要导出的数据！')
            return
          }
          this.exportDatas(array)
          break
        }
      }
    },
    batchDelete() {
      if (!this.selectDatas.length) {
        this.$message.warning('请先选择要删除的数据')
        return
      }
      let ids = this.selectDatas.map(item => item.id)
      this.deleteChcek(ids).then(checkPassIds => {
        if (checkPassIds.length === ids.length) {
          this.$confirm('该操作将永久删除所选类型，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.deleteData(checkPassIds)
            })
            .catch(() => {})
        } else {
          this.deleteData(checkPassIds)
        }
      })
    },
    selectChange(selection) {
      this.selectDatas = selection
    },
    deleteDataById(dataInfo) {
      let ids = [dataInfo.id]
      this.deleteChcek(ids).then(checkPassIds => {
        if (checkPassIds?.length) {
          this.$confirm('该操作将永久删除所选类型，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.deleteData(checkPassIds)
            })
            .catch(() => {})
        }
      })
    },
    openEditDialog(dataInfo) {
      // prettier-ignore
      this.currDictionary = dataInfo ? dataInfo : { typeId: this.currCatalog.id }
      this.isCatalogDialogVisible = true
    },
    closeEditDialog() {
      this.currDictionary = {}
      this.isCatalogDialogVisible = false
    },
    openImportDialog() {
      this.isImportDialogVisible = true
    },
    closeImportDialog() {
      this.isImportDialogVisible = false
    },
    exportDatas(array) {
      const content = array.join('\n') // 将数组的每一项用换行符连接成字符串
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' }) // 创建 Blob 对象

      // 创建一个链接元素
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob) // 生成下载链接
      link.download = `${this.currCatalog.name}.txt` // 设置下载文件名

      // 触发下载
      link.click()

      // 释放 URL 对象
      URL.revokeObjectURL(link.href)
    },
    async deleteData(ids) {
      let response = await batchDeleteDataDictionaryService({ ids })
      if (response.isSuccess) {
        this.refreshDictionaryList()
        this.$message.success('删除成功')
      } else {
        this.$message.error(response.errMsg)
      }
    },
    deleteChcek(ids) {
      return new Promise(resolve => {
        deleteDataDictionaryCheckService({ ids }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let warningMsg = ''
            let isShowCancelButton = true
            if (!data.errorList.length) {
              resolve(ids)
              return
            }
            let idsToDelete = []
            if (data.errorList.length === ids.length) {
              warningMsg = '当前所选类型均已被引用，无法执行删除操作。'
              isShowCancelButton = false
            }
            if (data.errorList.length < ids.length) {
              // prettier-ignore
              warningMsg = '检测到部分类型已被引用，这些类型无法删除。是否继续删除其余未被引用的类型？'
              isShowCancelButton = true
              idsToDelete = data.successList
            }
            this.$confirm(warningMsg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: isShowCancelButton,
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                resolve(idsToDelete)
              })
              .catch(() => {
                console.log('取消')
              })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    async refreshDictionaryList(isNotReturnToFirstPage = false) {
      this.currPage = !isNotReturnToFirstPage ? 1 : this.currPage
      let dataList = await this.queryDictionaryList()
      this.dataList = dataList
    },
    async queryDictionaryList() {
      let typeId = this.currCatalog.id
      let params = {
        skipCount: (this.currPage - 1) * this.pageSize,
        resultCount: this.pageSize,
        typeId: typeId,
        name: this.keywords
      }

      let response = await getDataDictionaryService(params)
      if (response.isSuccess) {
        let data = response.data
        this.total = data.totalCount
        return data.items
      } else {
        this.$message.error(response.errMsg)
      }
    },
    isOperationVisible() {
      const permissionCodes = [
        'Project.Single.ProjectDataDictionary.Update',
        'Project.Single.ProjectDataDictionary.Delete'
      ]
      return permissionCodes.some(permissionCode =>
        this.isChecked(permissionCode)
      )
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';

.data-dictionary-box {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  gap: 16px;
  padding: 0px 16px 16px 16px;

  .content-box {
    flex-grow: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    background: var(--page-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border-radius: 16px;
    border: 1px solid var(--page-border-color);
    padding: 16px;
    padding-bottom: 0px;

    .header-box {
      text-align: left;
      color: var(--page-title-color);
    }

    .operation-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 16px 0px;

      .action-box {
        display: flex;
        align-items: center;
      }
    }

    .common-table-box {
      flex-grow: 1;
      position: relative;
      overflow: hidden;

      .loading-box {
        position: relative;
        width: 100%;
        height: 100%;
      }

      .common-button-box {
        justify-content: flex-start;
        gap: 24px;
      }
    }

    .common-pagination-box {
      flex-shrink: 0;
    }
  }
}
</style>
